import React from 'react';

import { blueGrey ,grey } from '@material-ui/core/colors';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';

import FoxyTimeTrackerLogo from 'resources/images/foxy-timetracker-logo-512.png';
import FoxyTimeTrackerLogoWhite from 'resources/images/foxy-timetracker-logo-white-512.png';

// Surrounds child form with Foxy branding
function LandingFormFrame(props) {
    const theme = useTheme();

    const colors = theme.light()
        ? {
              text: grey[700],
              accent: blueGrey[600]
          }
        : {
              text: grey[500],
              accent: theme.palette.grey[50]
          };

    const logo = theme.light() ? FoxyTimeTrackerLogo : FoxyTimeTrackerLogoWhite;

    return (
        <Box maxWidth={360} p={2}>
            <Box display="flex" alignItems="center" flexDirection="column">
                <img src={logo} alt="globalHS" style={{ width: 64 }} />
                <Typography
                    variant="h4"
                    style={{
                        marginTop: theme.spacing(2),
                        color: colors.text,
                        fontWeight: 500,
                        fontSize: '1.75rem'
                    }}
                >
                    shule<span style={{ fontWeight: 400 }}>Yangu</span>
                </Typography>
            </Box>

            <Box marginTop={2}>{props.children}</Box>
        </Box>
    );
}

export default LandingFormFrame;
